<template>
    <div class="modal-content" id="SelectPaymentMethod" v-b-visible="displayed">
        <div class="modal-header">
            <h5 class="modal-title" :id="modalComponent + 'Title'">Sijoituksen maksaminen</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-close"></i>
            </button>
        </div>
        <div class="modal-body" id="SelectPaymentBody" ref="SelectPaymentBody">
            <div v-if="purchaseState === 10">
                <p class="text-left">Valitse pankki, jonka kautta haluat maksaa sijoituksen. Verkkopankissa ja tiliotteella maksun
                saajana lukee Euteller Oy, joka toimii maksunvälittäjänä.</p>
                <div class="bankArea">
                    <div v-for="(item, idx) in banks" :key="idx" class="bankDiv" @click="paymentSelected(item.id)">
                        <div class="bankLogoDiv cursor-pointer">
                            <img :src="'/bankLogos/' + item.file" class="bankLogo" />
                        </div>
                    </div>
                </div>
            </div>
            <ModalLoader v-else-if="purchaseState <= 1" message="Odota hetki, varataan osakkeita"></ModalLoader>
            <ModalLoader v-else message="Odota hetki, sinut siirretään verkkopankkiisi..."></ModalLoader>
        </div>
        <div class="modal-footer" style="justify-content: normal">
            <button type="button" class="btn btn-outline-secondary pull-left" data-dismiss="modal">Peruuta sijoitus</button>
        </div>
    </div>
</template>

<script>

    import ModalLoader from "@/components/Modals/ModalLoader";
    export default {
        name: "SelectPaymentMethod",
        components: {ModalLoader},
        props: ['modalComponent'],
        data: function () {
            return {
                banksVisible: true,
                banks: [
                    {
                        id: 'aktia',
                        file: 'Aktia-300x96.png'
                    },
                    {
                        id: 'alandsbanken',
                        file: 'Alandsbanken-300x24.png'
                    },
                    {
                        id: 'danske',
                        file: 'DanskeBank-300x45.png'
                    },
                    {
                        id: 'handelsbanken',
                        file: 'Handelsbanken-300x31.png'
                    },
                    {
                        id: 'nordea',
                        file: 'Nordea-300x67.png'
                    },
                    {
                        id: 'omasp',
                        file: 'Omasaastopankki-300x122.png'
                    },
                    {
                        id: 'op',
                        file: 'Osuuspankki-150x150.png'
                    },
                    {
                        id: 'pop',
                        file: 'POP-300x67.png'
                    },
                    {
                        id: 'spankki',
                        file: 'S-Pankki-300x60.png'
                    },
                    {
                        id: 'saastopankki',
                        file: 'Saastopankki-300x55.png'
                    }
                ]
            }
        },
        computed: {
            purchaseInfo: function () {
                let val = this.$store.state.purchase.purchase
                return val
            },
            purchaseState: {
                get: function () {
                    return this.$store.state.purchase.purchase.state
                }
            },
            availableSeries: {
                get: function () {
                    let src = Object.assign({}, this.$store.getters.getAvailableSeries);
                    return src
                }
            },
            availableSeriesCount: function () {
                let x = this.$store.state.purchase.availableShares.shareSeries
                let cnt = Object.keys(x).length
                return cnt
            }
        },
        methods: {
            paymentSelected: function (bank) {
                this.banksVisible = false
                this.$store.dispatch('activatePurchase', bank)
            },
            paymentRedirect: function () {

                //$('#SelectPaymentMethod').modal('hide')
                this.$emit('closeModal', true)
                this.$router.push({ name: 'HandlePayment' })
            },
            displayed: function (isVisible) {
                if (isVisible) {
                    if (this.purchaseState === 1) {
                        this.$store.dispatch('reservePurchase')
                    }
                }
            }
        },
        watch: {
            purchaseState: function (newVal) {
                console.log(newVal)
            }
        },
        mounted: function () {
            /*
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                console.log('Modal is about to be shown', bvEvent, modalId)
            })
            */
        }
    }
</script>

<style scoped>
    .bankLogo {
        display: inline-block;
        max-width: 75px;
        max-height: 75px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        margin: auto;
    }

    .bankLogoDiv {
        height: 70px;
        display: block;
        position: relative;
    }

    .bankDiv {
        float: left;
        margin: 10px;
        width: 75px;
        height: 75px;
    }

    .bankArea {
        padding: 10px 30px;
        text-align: center;
    }
</style>
